import { Injectable } from '@angular/core';
import { ICustomerFilter } from '../interfaces/customer-filter';
import { IInboxJobFilter } from '../interfaces/inbox-job-filter';
import { ITaskFilter } from '../interfaces/task-filter';

@Injectable({ providedIn: 'root' })
export class FilterStateService {
  public inboxJobFilterVal?: IInboxJobFilter;
  public taskFilterVal?: ITaskFilter;
  public orgFilterVal?: ICustomerFilter;
  public scrollPosition?: number;
}
